import { InputText, InputTextProps } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type RHFInputTextProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    disabled?: boolean;
    placeholder?: string;
    inputProps?: InputTextProps;
};

export const RHFInputText = ({ control, name, rules, disabled, placeholder, inputProps }: RHFInputTextProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            disabled={disabled}
            render={({ field, fieldState }) => (
                <InputText
                    id={field.name}
                    {...field}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    placeholder={placeholder}
                    {...inputProps}
                />
            )}
        />
    );
};
